import { Popover, Transition } from "@headlessui/react";
import { ComponentProps, Fragment, useRef } from "react";
import { twMerge } from "tailwind-merge";

import { UserAvatar } from "@/components/user-avatar";

import { UserSection } from "./shared/user-section/UserSection";

export const UserPopover = (props: ComponentProps<typeof Popover>) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  let timeout: NodeJS.Timeout;

  const toggleMenu = (open: boolean) => {
    clearTimeout(timeout);
    if (open) {
      timeout = setTimeout(() => buttonRef?.current?.click(), 50);
    }
  };

  return (
    <Popover {...props} className={twMerge("relative", props.className)}>
      {({ open }) => (
        <div
          onMouseEnter={() => toggleMenu(!open)}
          onMouseLeave={() => toggleMenu(open)}
        >
          <Popover.Button
            ref={buttonRef}
            className="flex items-center focus:outline-none"
            aria-label="open user popover"
          >
            <UserAvatar width={32} height={32} />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Popover.Panel className="absolute right-0 z-10 mt-2 min-w-56 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              {({ close }) => <UserSection close={close} />}
            </Popover.Panel>
          </Transition>
        </div>
      )}
    </Popover>
  );
};
